<template>
  <v-card class="pa-2" width="400">
    <v-card-title>{{ cardTitle }}</v-card-title>
    <v-form fast-fail class="d-flex flex-column" @submit.prevent>
      <slot name="fields" />
      <v-row>
        <v-col class="d-flex justify-end" col="12">
          <slot name="actions" />
        </v-col>
      </v-row>
    </v-form>
  </v-card>
</template>

<script lang="ts" setup>
  defineProps({
    cardTitle: {
      type: String,
      default: '',
    },
  });
</script>
